goog.provide("shadow.js.shim.module$date_fns$formatISO$default");
shadow.js.shim.module$date_fns$formatISO$default = esm_import$date_fns$formatISO.default;
